




































































import { Vue, Component, Prop } from 'vue-property-decorator';
import TraceDetailChartList from './trace-detail-chart-list.vue';
import TraceDetailChartTree from './trace-detail-chart-tree.vue';
import TraceDetailChartTable from './trace-detail-chart-table.vue';
import { Trace, Span } from '@/types/trace';
import { Action, State } from 'vuex-class';
import copy from '@/utils/copy';

@Component({ components: { TraceDetailChartList, TraceDetailChartTree, TraceDetailChartTable } })
export default class TraceDetail extends Vue {
  @State('rocketbot') private rocketbot: any;
  @Action('rocketTrace/GET_TRACE_SPANS') private GET_TRACE_SPANS: any;
  @Prop() private spans!: Span[];
  @Prop() private current!: Trace;
  private mode: boolean = true;
  private displayMode: string = 'list';
  private handleClick(ids: any) {
    let copyValue = null;
    if (ids.length === 1) {
      copyValue = ids[0];
    } else {
      copyValue = ids.join(',');
    }
    copy(copyValue);
  }
}
